<template>
    <IntegrationStoreSettingsLayout @save="saveAndContinue"
                                    @cancel="preventLeavingWithUnsavedChanges"
    >
        <div v-if="store.attributes.address.country === 'de'">
            <FormGroupNew label="Umsatzsteuer-ID"
                          description="Bitte geben Sie die Ust-Id. des Geschäfts an."
                          :error="config.errors.ust_id"
                          :required="requiredFields.includes('ust_id')"
            >
                <input type="text" class="form-control" v-model="config.ust_id">
            </FormGroupNew>
        </div>
        <div v-if="store.attributes.address.country === 'de'" class="row">
            <div class="col-md-6">
                <FormGroupNew label="Handelsregistergericht"
                              description="Bitte geben Sie das verantwortliche Handelsregistergericht des Geschäfts an."
                              :error="config.errors.trade_reg_court"
                              :required="requiredFields.includes('trade_reg_court')"
                >
                    <input type="text" class="form-control" v-model="config.trade_reg_court">
                </FormGroupNew>
            </div>
            <div class="col-md-6">
                <FormGroupNew label="Handelsregisternummer"
                              description="Bitte geben Sie die Handelsregisternummer des Geschäfts an."
                              :error="config.errors.trade_reg_num"
                              :required="requiredFields.includes('trade_reg_num')"
                >
                    <input type="text" class="form-control" v-model="config.trade_reg_num">
                </FormGroupNew>
            </div>
        </div>

        <div v-if="store.attributes.address.country === 'at'">
            <FormGroupNew label="Registernummer"
                          description="Bitte geben Sie die Registernummer des Geschäfts an."
                          :error="config.errors.reg_id"
                          :required="requiredFields.includes('reg_id')"
            >
                <input type="text" class="form-control" v-model="config.reg_id">
            </FormGroupNew>
        </div>

        <FormGroupNew :label="__('sale.shipping')"
                      :error="config.errors.shipping_active"
                      :required="requiredFields.includes('shipping_active')"
        >

            <Checkbox v-model="config.shipping_active" form-control>
                {{ __('actions.enable_thing', {thing: __('sale.shipping')}) }}
            </Checkbox>
        </FormGroupNew>

        <FormGroupNew :label="__('general.shipping_cost')"
                      :error="config.errors.shipping_cost"
                      :required="requiredFields.includes('shipping_cost')"
        >
            <input type="number" class="form-control" v-model="config.shipping_cost" :disabled="!config.shipping_active">
        </FormGroupNew>
    </IntegrationStoreSettingsLayout>
</template>

<script>
import IntegrationStoreSettingsLayout from "@layouts/IntegrationStoreSettingsLayout.vue";
import IntegrationStoreConfigMixin from "@mixins/IntegrationStoreConfigMixin";
import FormErrors from "@components/Form/FormErrors.vue";
import FormGroupNew from "@components/Form/FormGroupNew.vue";
import Checkbox from "@components/Form/Checkbox.vue";

export default {
    components: {Checkbox, FormGroupNew, FormErrors, IntegrationStoreSettingsLayout},

    mixins: [IntegrationStoreConfigMixin],
}
</script>
